export const CHART_COLORS = {
  LEFT: '#326EDC',
  RIGHT: '#4DC6DF',
}
export const CHART_UNIT = {
  DAY: 'day',
  HOUR: 'hour',
}
export const CHART_DATE_FORMAT = 'YYYYMMDD'
export const CHART_OPTION_GROUPS = {
  id: 'defaults',
  title: '기본지표',
  options: [
    {
      text: '노출수',
      value: 'viewableImpression',
    },
    {
      text: '클릭수',
      value: 'click',
    },
    {
      text: '클릭률',
      value: 'ctr',
    },
    {
      text: '비용',
      value: 'spending',
    },
  ],
}
export const CHART_OPTION_ADD_GROUPS = {
  id: 'add',
  title: '추가지표',
  options: [
    {
      text: '전체노출수',
      value: 'renderedImpression',
    },
    {
      text: '클릭당비용',
      value: 'ppc',
    },
    {
      text: '평균노출순위',
      value: 'rank',
    },
    {
      text: '노출당비용',
      value: 'costPerImp',
    },
  ],
}
export const CHART_OPTION_PIXEL_AND_SDK_GROUPS = {
  id: 'pixelAndSdk',
  title: '픽셀&SDK 전환 지표',
  options: [
    {
      text: '앱 설치(7일)',
      value: 'convAppInstall7d',
    },
    {
      text: '회원가입(7일)',
      value: 'convCmptReg7d',
    },
    {
      text: '장바구니 보기(7일)',
      value: 'convViewCart7d',
    },
    {
      text: '구매(7일)',
      value: 'convPurchase7d',
    },
    {
      text: '구매금액(7일)',
      value: 'convPurchaseP7d',
    },
    {
      text: '잠재고객(7일)',
      value: 'convParticipation7d',
    },
    {
      text: '서비스 신청(7일)',
      value: 'convSignup7d',
    },
    {
      text: '앱 설치(1일)',
      value: 'convAppInstall1d',
    },
    {
      text: '회원가입(1일)',
      value: 'convCmptReg1d',
    },
    {
      text: '장바구니 보기(1일)',
      value: 'convViewCart1d',
    },
    {
      text: '구매(1일)',
      value: 'convPurchase1d',
    },
    {
      text: '구매금액(1일)',
      value: 'convPurchaseP1d',
    },
    {
      text: '잠재고객(1일)',
      value: 'convParticipation1d',
    },
    {
      text: '서비스 신청(1일)',
      value: 'convSignup1d',
    },
  ],
}

export const CHART_OPTION_TALK_CHANNEL_GROUPS = {
  id: 'talkChannel',
  title: '카카오 친구 지표',
  options: [
    {
      text: '친구 추가 수(7일)',
      value: 'convKfPfAdd7d',
    },
    {
      text: '친구 추가 수당 비용(7일)',
      value: 'costPerConvKfPfAdd7d',
    },
    {
      text: '친구 추가율(7일)',
      value: 'convKfPfAdd7dRate',
    },
    {
      text: '친구 추가 수(1일)',
      value: 'convKfPfAdd1d',
    },
    {
      text: '친구 추가 수당 비용(1일)',
      value: 'costPerConvKfPfAdd1d',
    },
    {
      text: '친구 추가율(1일)',
      value: 'convKfPfAdd1dRate',
    },
  ],
}

export const ChartOptions = [
  ...CHART_OPTION_GROUPS.options,
  ...CHART_OPTION_ADD_GROUPS.options,
  ...CHART_OPTION_PIXEL_AND_SDK_GROUPS.options,
  ...CHART_OPTION_TALK_CHANNEL_GROUPS.options,
]
